import React, { Component, Fragment } from "react";
import i18n from "../../../../i18n";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeDropper } from "@fortawesome/free-solid-svg-icons";

export class View extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
render() {
    const {data}=this.props
    return ( <React.Fragment>
        <div className="row">
            <div className="col-12">
              <Table >
                <thead>
                </thead>
                <tbody>
                  <tr style={{fontSize:'15px', fontWeight:'bold'}}><td>{i18n.t("Date")}</td>
                  <td>:</td><td>{(data?.date_format)?data?.date_format:'-'}</td></tr>
                  <tr style={{fontSize:'15px', fontWeight:'bold'}}><td>{i18n.t("Branch Name")}</td>
                  <td>:</td><td>{(data?.name_branch)?data?.name_branch:'-'}</td></tr>
                  <tr style={{fontSize:'15px', fontWeight:'bold'}}><td>{i18n.t("Status")}</td>
                  <td>:</td><td>{(data?.status_due)?data?.status_due:'-'}</td></tr>
                  
                </tbody>
              </Table>
              
            </div>
          </div>
          <div className="row">
            <Table >
                <thead>
                    <tr>
                        <th>{i18n.t('Name')}</th>
                        <th>{i18n.t('Value')}</th>
                        <th>{i18n.t('Fill Color')}</th>
                        <th>{i18n.t('Calculate')}</th>
                        <th>{i18n.t('Status')}</th>
                    </tr>
                </thead>
                <tbody>
                  {data?.details.map((item,index)=>{
                    return (
                        <tr key={'itemModal'+index}>
                            <td>
                                {item?.name}
                            </td>
                            <td align="right">
                                {item?.value} {(item?.type=='percentage')?'%':''} 
                            </td>
                            <td align="center">
                                <Button variant="ghost" className="cursor-pointer hover:opacity-80" style={{backgroundColor:item?.bgColor}} onClick={()=>{}}>
                                    {/* <FontAwesomeIcon icon={faEyeDropper} color={iconColor}></FontAwesomeIcon> */}
                                </Button>
                            </td>
                            <td align="center">
                                {i18n.t(item.calculate?'Yes':'No')}
                            </td>
                            <td align="center">
                                {i18n.t(item.calculate?'Yes':'No')}
                            </td>
                        </tr>
                    )
                  })}
                  
                </tbody>
              </Table>
          </div>
       </React.Fragment> 
    );
  }
}

export default View;
